import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const voucherConfigApi = {
  list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/vouchers-config/`, {params: params})
  },
  detail (voucherConfigId, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/vouchers-config/${voucherConfigId}/`, {params: params})
  },
  update (voucherConfigId, params) {
    return axios.put(
      `${ApiSetting.baseUrl}/api/vouchers-config/${voucherConfigId}/`, querystring.stringify(params))
  },
}

export default voucherConfigApi
